import AuthErrorPage from "@components/Common/AuthErrorPage";
import { DevConfigPopup } from "@components/Common/DevConfigPopup";
import InitializationError from "@components/Common/InitializationError";
import LoadingSpinner from "@components/Common/LoadingSpinner";
import { useAppConfigFetcher } from "@hooks/useAppConfigFetcher";
import { useIframeSetup } from "@hooks/useIframeSetup";
import { useParentCommunication } from "@hooks/useParentCommunication";
import { useRuntimeUpdates } from "@hooks/useRuntimeUpdates";
import { selectHasAuthError } from "@store/slices/authError";
import { useSelector } from "react-redux";

interface AppInitializerProps {
  children: React.ReactNode;
}

export const AppInitializer: React.FC<AppInitializerProps> = ({ children }) => {
  const { 
    error: authError,
    showDevConfig,
    handleDevConfigSubmit,
    authData
  } = useParentCommunication();
  
  const { error: configError, isReady: configReady } = useAppConfigFetcher(authData?.appId);
  
  const hasAuthError = useSelector(selectHasAuthError);
  
  useRuntimeUpdates();
  useIframeSetup(!!authData && configReady);

  if (hasAuthError) {
    return (
      <AuthErrorPage 
        onRetry={() => globalThis.location.reload()} 
      />
    );
  }

  if (authError) {
    return <InitializationError error={authError} onRetry={() => globalThis.location.reload()} />;
  }

  if (showDevConfig) {
    return <DevConfigPopup onSubmit={handleDevConfigSubmit} />;
  }

  if (!authData || !configReady) {
    return <LoadingSpinner />;
  }

  if (configError) {
    console.error("App configuration error:", configError);
  }

  return <>{children}</>;
};
